var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stars-container",attrs:{"aria-label":"Rating stars"}},[_c('span',{staticClass:"rate"},_vm._l((_vm.stars),function(star,index){return _c('i',{key:index,class:{
        selected: index + 1 <= _vm.selectedRating,
        readonly: _vm.readonly,
      },attrs:{"aria-label":'Star ' + (index + 1)},on:{"click":function($event){!_vm.readonly && _vm.setRating(index + 1)}}},[_vm._v(" "+_vm._s(star)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }